module.exports = __webpack_public_path__ + "img/035-invitation.7ec9fc3e.png";